<template>
  <div class="h-playground-rank">
    <p class="popup-header">游乐场排行榜</p>
    <div class="rank-list" v-if="rankList.length">
      <div class="rank-item h-bg brown-2 h-outer-border around-4 bw2 bz0"
           v-for="(item, index) in rankList">
        <div class="rank">
          <template v-if="index < 3">
            <img :src="`${$rHost}/img/common/rank/rank_${index +  1}.png`" alt="">
          </template>
          <template v-else>
            {{ index + 1 }}
          </template>
        </div>
        <div class="awatar-wrapper">
          <div class="avatar h-outer-border around-4 bw2 bz0">
            <template v-if="index < 3">
              <img class="effect" :src="`${$rHost}/img/common/effect/rect_gold_180_1.webp`" alt="">
            </template>
            <div class="icon-avatar-wrapper">
              <img class="icon-avatar" :src="item.avatar" alt="">
            </div>
          </div>
        </div>
        <div class="nick">{{ item.nick }}</div>
        <div class="stage">关卡 {{item.score}}</div>
        <div class="stars">{{item.metaScore ? `星数 ${item.metaScore}` : '-'}}</div>
      </div>
    </div>
    <div v-else class="empty h-bg brown-2 h-outer-border around-4 bw2 bz0">
      暂无排行
    </div>
  </div>
</template>

<script>
  import API from '@js/api'

  export default {
    name: 'playground-rank',

    data () {
      return {
        rankList: [],
      }
    },

    mounted () {
      this.getRankList()
    },

    methods: {
      async getRankList () {
        try {
          this.rankList = await API.playground.getRank({
            gameId: 1,
          })
        } catch (err) {
          console.error(err)
          this.$message(err)
        }
      },
    },

  }
</script>

<style lang="stylus" scoped>
  .h-playground-rank
    width 612px

  .empty
    whiteText1()
    padding 10px 0
    line-height 20px
    font-size 12px
    text-align center
    letter-spacing 2px

  .rank-list
    display flex
    flex-direction column
    flex-wrap wrap
    align-items center
    max-height 380px

  .rank-item
    width 302px
    display flex
    align-items center
    font-size 12px
    padding 3px 2px
    margin 0 2px 2px 2px
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3)
      .effect
        z-index 1
        position absolute
        top -7px
        left -7px
        width 42px
        height 42px
    &:nth-child(1) .effect
      filter hue-rotate(0deg)
    &:nth-child(2) .effect
      filter hue-rotate(215deg)
    &:nth-child(3) .effect
      filter hue-rotate(180deg) grayscale(0.6)
    .rank
      display flex
      justify-content center
      align-items center
      width 30px
      height 30px
      padding 0 1px
      line-height 30px
      text-align center
      font-size 12px
      text-shadow 0 2px 2px #000
      color $colorGold
      img
        max-width 100%
        filter drop-shadow(0 0 3px #000)
    .awatar-wrapper
      position relative
      width 30px
      height 30px
      border-radius 2px
      border 1px solid transparent
    .avatar
      position relative
      z-index 1
      width 28px
      height 28px
      padding 2px
      border-radius 2px
      .icon-avatar-wrapper
        position absolute
        top 2px
        left 2px
        z-index 0
        overflow hidden
        display flex
        justify-content center
        align-items center
        width 24px
        height 24px
        .icon-avatar
          max-width 100%
    .nick
      width 90px
      whiteText1()
      padding-left 5px
      letter-spacing 2px
      color #ddd
    .stage
      width 70px
      padding-right 2px
      flex-grow 1
      text-align right
      whiteText1()
      color #aaa
    .stars
      width 78px
      padding-right 2px
      flex-grow 1
      text-align right
      whiteText1()
      color #aaa

</style>
